import React from "react";
import { Link } from "react-router-dom";

function Latest() {
  const data = [
    {
      id: 1,
      name: "Life Insurance",
      img: "assets/images/portfolio/portfolio-1-1.jpg",
    },
    {
      id: 2,
      name: "Health Insurance",
      img: "assets/images/portfolio/portfolio-1-2.jpg",
    },
    {
      id: 3,
      name: "House Insurance",
      img: "assets/images/portfolio/portfolio-1-3.jpg",
    },
    {
      id: 4,
      name: "Car Insurance",
      img: "assets/images/portfolio/portfolio-1-4.jpg",
    },
    {
      id: 5,
      name: "Study Insurance",
      img: "assets/images/portfolio/portfolio-1-5.jpg",
    },
    {
      id: 6,
      name: "Family Insurance",
      img: "assets/images/portfolio/portfolio-1-6.jpg",
    },
    {
      id: 7,
      name: "Car Insurance",
      img: "assets/images/portfolio/portfolio-1-7.jpg",
    },
    {
      id: 8,
      name: "Life Insurance",
      img: "assets/images/portfolio/portfolio-1-8.jpg",
    },
    {
      id: 9,
      name: "Business Insurance",
      img: "assets/images/portfolio/portfolio-1-9.jpg",
    },
  ];
  return (
    <>
      <section className="portfolio-grid">
        <div className="container">
          <div className="sec-title text-center">
            <p className="sec-title__tagline">latest project</p>

            <h3 className="sec-title__title">Take a Look Our Projects</h3>
          </div>

          <div className="text-center">
            <ul className="list-unstyled post-filter portfolio-filter">
              <li data-filter=".filter-item" className="active">
                <div className="filter-text">Show All</div>
              </li>
              <li data-filter=".house">
                <div className="filter-text">House</div>
              </li>
              <li data-filter=".life">
                <div className="filter-text">Life</div>
              </li>
              <li data-filter=".business">
                <div className="filter-text">Business</div>
              </li>
              <li data-filter=".car">
                <div className="filter-text">Car</div>
              </li>
              <li data-filter=".travel">
                <div className="filter-text">Travel</div>
              </li>
              <li data-filter=".study">
                <div className="filter-text">Study</div>
              </li>
            </ul>
          </div>

          <div className="row filter-layout masonary-layout gutter-y-30">
            {data.map((item) => (
              <div className="col-md-6 col-lg-4 filter-item life" key={item.id}>
                <div className="portfolio-card">
                  <div className="portfolio-card__image">
                    <img src={item.img} />
                    <div className="portfolio-card__content">
                      <span className="portfolio-card__tagline">Insurance</span>

                      <h3 className="portfolio-card__title">
                        <Link to="/portfoliodetails">{item.name}</Link>
                      </h3>
                      <Link
                        to="/portfoliodetails"
                        className="portfolio-card__link"
                      >
                        <i className="far fa-arrow-right" />
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="portfolio-grid__btns text-center">
            <Link
              to="/portfoliogrid"
              className="thm-btn thm-btn--two portfolio-grid__btn"
            >
              <span>
                View More Project
                <i className="far fa-arrow-right" />
              </span>
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}

export default Latest;
